'use client';

import dynamic from 'next/dynamic';
import { Loader } from '@/shared/components/primitives/loader';

// The gate is mounted on every page but closed by default: its forms (zod, react-hook-form)
// load on first open instead of in every page's first-load JS (WTDEV-1776).

const AuthGateViewLoading = () => (
  <div className='flex min-h-72 items-center justify-center'>
    <Loader color='primary' size={32} />
  </div>
);

export const LazyLoginFormContainer = dynamic(
  () =>
    import('@/features/auth/internal/components/login/login-form-container').then(
      (mod) => mod.LoginFormContainer,
    ),
  { ssr: false, loading: AuthGateViewLoading },
);

export const LazyCreateAccountForm = dynamic(
  () =>
    import('@/features/auth/shared/components/create-account/create-account-form').then(
      (mod) => mod.CreateAccountForm,
    ),
  { ssr: false, loading: AuthGateViewLoading },
);

export const LazyVerifyEmailContent = dynamic(
  () =>
    import('@/features/auth/internal/components/verify-email/verify-email-content').then(
      (mod) => mod.VerifyEmailContent,
    ),
  { ssr: false, loading: AuthGateViewLoading },
);
